import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@pointfive/tokens/nocturne.css'; // the design-system sheet the reference links first (line-height 1.55, focus ring, resets)
import '@pointfive/tokens/tokens.css';
import '@pointfive/tokens/base.css';
import './host.css';
import { App } from './app/App';
import { onPrice } from './client/price-feed';
import { anchorMarketData, SERVER_HISTORY_REQUIRED, setTickSource } from './screens/chart-adapter';

// Before the first render: the chart series has to reach the present, or every chart draws an empty pane. See
// `screens/chart-adapter.ts` — this is the design package's own `register()` extension point, not a patch to it.
anchorMarketData();

// Live ticks, http binding only (SM-P6-04): the adapter's subscription seam gets the ticketed price feed as its
// source. Under the sim there is no fabric and deliberately no fake one — the seam stays quiet and says so.
if (SERVER_HISTORY_REQUIRED) setTickSource((symbol, handler) => onPrice(symbol, handler));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
